import { formatInr } from "../../../lib/currency";

export type ActivityFeedItem = {
  id: string;
  type: "sale" | "invoice" | "order";
  title: string;
  description: string;
  time: string;
  amount?: string;
};

function relativeTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return "—";
  const msAgo = Date.now() - t;
  const s = Math.floor(msAgo / 1000);
  const m = Math.floor(s / 60);
  const h = Math.floor(m / 60);
  const dday = Math.floor(h / 24);
  if (s < 60) return `${s} seconds ago`;
  if (m < 60) return `${m} minutes ago`;
  if (h < 24) return `${h} hours ago`;
  return `${dday} days ago`;
}

type Row = {
  type: string;
  reference: string;
  label: string;
  amount: string | null;
  created_at: string | null;
  customer?: string | null;
};

export function mapRecentActivityToFeed(rows: Row[]): ActivityFeedItem[] {
  return rows.map((a, idx) => {
    const amountNum = Number(a.amount ?? 0);
    const amount = Number.isFinite(amountNum) ? formatInr(amountNum) : undefined;

    if (a.type === "purchase") {
      return {
        id: `act_${idx}_${a.reference}`,
        type: "order",
        title: `Purchase — ${a.reference}`,
        description: a.label,
        time: relativeTime(a.created_at),
        amount,
      };
    }
    if (a.type === "inventory") {
      return {
        id: `act_${idx}_${a.reference}`,
        type: "invoice",
        title: `Stock in — ${a.reference}`,
        description: a.label,
        time: relativeTime(a.created_at),
        amount,
      };
    }
    const cust =
      typeof a.customer === "string" && a.customer.trim() !== "" && a.customer !== "-"
        ? a.customer.trim()
        : null;
    return {
      id: `act_${idx}_${a.reference}`,
      type: "sale",
      title: `Sale — ${a.reference}`,
      description: cust ? `Customer: ${cust}` : a.label,
      time: relativeTime(a.created_at),
      amount,
    };
  });
}
